export const INTEGRATION_HEADLINE = {
    salesforce: "si.management.sf.integration.page.headline",
    hubspot: "si.management.hs.integration.page.headline",
    dynamics: "si.management.dynamics.integration.page.headline",
};

export const BREADCRUMB_INTEGRATIONS = "si.management.breadcrumbs.integrations";

export const BREADCRUMB_MANAGE_INTEGRATION = {
    salesforce: "si.management.breadcrumbs.manage-sf-integration",
    hubspot: "si.management.breadcrumbs.manage-hs-integration",
    dynamics: "si.management.breadcrumbs.manage-dynamics-integration",
};

export const BREADCRUMB_EXPORT_FIELD_MAPPING = "si.management.breadcrumbs.export-field-mapping";

export const BREADCRUMB_ENRICHMENT_SETTINGS = "si.management.breadcrumbs.enrichment-settings";

export const MANAGEMENT_INTEGRATION_EXCLUDE_TOOLTIP = {
    salesforce: "si.management.sf.integration.tab.exclude.section.toggle.tooltip",
    hubspot: "si.management.hs.integration.tab.exclude.section.toggle.tooltip",
    dynamics: "si.management.dynamics.integration.tab.exclude.section.toggle.tooltip",
};

export const MANAGEMENT_INTEGRATION_EXCLUDE_DETAILS = {
    salesforce: "si.management.sf.integration.tab.exclude.section.details",
    hubspot: "si.management.hs.integration.tab.exclude.section.details",
    dynamics: "si.management.dynamics.integration.tab.exclude.section.details",
};

export const MANAGEMENT_INTEGRATION_EXCLUDE_DROPDOWN_SEARCH_PLACEHOLDER = {
    salesforce: "si.management.sf.integration.tab.exclude.section.dropdown.search.placeholder",
    hubspot: "si.management.hs.integration.tab.exclude.section.dropdown.search.placeholder",
    dynamics: "si.management.dynamics.integration.tab.exclude.section.dropdown.search.placeholder",
};

export const MANAGEMENT_INTEGRATION_EXCLUDE_TITLE = "si.management.integration.tab.exclude.section.title";

export const MANAGEMENT_INTEGRATION_LABEL_TOOLTIP = "si.management.sf.integration.tab.dropdown.label.tooltip";

export const MANAGEMENT_EXPORT_PREFERENCES_TITLE = "si.management.integration.export.preferences.title";

export const MANAGEMENT_EXPORT_PREFERENCES_TITLE_TOOLTIP = {
    hubspot: "si.management.hs.integration.export.preferences.title.tooltip",
};

export const MANAGEMENT_EXPORT_PREFERENCES_SUBTITLE = "si.management.integration.export.preferences.subtitle";

export const MANAGEMENT_EXPORT_PREFERENCES_EDIT_BUTTON = "si.management.integration.export.preferences.edit.button";

export const MANAGEMENT_INTEGRATION_SF_ACTIVITY_TITLE = "si.manage-integration.sf-activity.title";

export const MANAGEMENT_INTEGRATION_SF_ACTIVITY_DESCRIPTION = "si.manage-integration.sf-activity.description";
export const MANAGEMENT_INTEGRATION_SF_ACTIVITY_FEED_LEVEL_USER = "si.manage-integration.sf-activity.feed-level.user";
export const MANAGEMENT_INTEGRATION_SF_ACTIVITY_FEED_LEVEL_ACCOUNT =
    "si.manage-integration.sf-activity.feed-level.account";
export const MANAGEMENT_INTEGRATION_SF_ACTIVITY_BANNER_TEXT = "si.manage-integration.sf-activity.banner.text";
export const MANAGEMENT_INTEGRATION_SF_ACTIVITY_BANNER_BUTTON = "si.common.view-terms";

export const MANAGEMENT_EXPORT_PREFERENCES_MAPPED_FIELDS = "si.management.integration.export.preferences.mapped.fields";

export const MANAGEMENT_EXPORT_PREFERENCES_REQUIRED_FIELDS_WARNING = {
    singular: "si.management.integration.export.preferences.required-fields-warning.singular",
    plural: "si.management.integration.export.preferences.required-fields-warning.plural",
};

export const DELETE_TOOLTIP = "si.management.sf.settings_export.settings.table.btn.delete.label";
